module.exports = __webpack_public_path__ + "img/logo_square_small.8c32eb2f.png";